import React, { useCallback } from "react";
import { CallbackComponent } from "redux-oidc";
import { getAdminDetails, profileSuccess } from "../reducers/authReducer";
import { userManager } from "./index";
import { useNavigate } from "react-router-dom";
import store from 'src/store/index';
const CallbackPage = (props) => {
    const navigate = useNavigate();

    const handleRedirect = (user) => {
        store.dispatch(profileSuccess(user));
        store.dispatch(getAdminDetails(user?.profile?.sub));
        const url = localStorage.getItem("__url");
        navigate(url && url !== "/callback" ? url : "/")
        localStorage.removeItem("__url");
    }
    const handleSuccess = useCallback((user) => {
        handleRedirect(user);
    }, [handleRedirect])
    const handleError = useCallback((error) => {
        console.error(error.message);
    }, [])
    return (
        <CallbackComponent
            userManager={userManager}
            successCallback={handleSuccess}
            errorCallback={handleError}
        >
            <div className="loader"></div>
        </CallbackComponent>
    );
}
export default (CallbackPage);